import { isCustomFilter, isGroupFilter, isLLMDecisionFilter } from './types';
import { camelToSnakeCaseKeys } from 'services/helpers';
import { loadSavedFilter } from 'ts-filters/utils';
import {
  BELOW_THRESHOLD_ACTION_OPTIONS,
  MERGE_FIELD_VALIDATION_OPTIONS,
} from './LLMDecision/constants';

export const createWizardState = async (
  state,
  metaData,
  queryClient,
  filterVariablesObject
) => {
  const stateData = {
    type: state?.details.type || null,
    groups: state?.details.groups || [],
    filter: { and: null, query: [] },
    llmDecision: {
      modelName: undefined,
      businessPluginAppId: undefined,
      prompt: '',
      htmlPrompt: '',
      mergeFieldValidation: MERGE_FIELD_VALIDATION_OPTIONS.default_to_unknown,
      confidenceThreshold: 0.5,
      belowThresholdAction: BELOW_THRESHOLD_ACTION_OPTIONS.fail_the_step,
    },
  };

  if (!state) {
    return stateData;
  }

  if (state.details.filterConfig) {
    const data = await loadSavedFilter(
      metaData,
      camelToSnakeCaseKeys(state.details.filterConfig),
      filterVariablesObject,
      queryClient
    );

    stateData.filter = {
      config: data,
      and: state.details.filterConfig.and,
    };
  }

  if (state.details.llmDecision) {
    stateData.llmDecision = state.details.llmDecision;
  }

  return stateData;
};

export const createPayload = (values, state = {}, filterConfig) => {
  return {
    ...state,
    details: {
      type: values.type,
      groups: (isGroupFilter(values.type) && values.groups) || [],
      filterConfig: isCustomFilter(values.type) ? filterConfig : null,
      llmDecision: isLLMDecisionFilter(values.type) ? values.llmDecision : null,
    },
  };
};
